/* 🤖 this file was generated by svg-to-ts */
export const matIconExpandLess: {
  name: 'expand-less';
  data: string;
} = {
  name: 'expand-less',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"/></svg>`
};
